export const CURRICULUM = {
  3: {
    label: "Grade 3",
    emoji: "🌱",
    color: "#FF6B6B",
    topics: [
      {
        id: "g3-add-sub",
        name: "Addition & Subtraction",
        emoji: "➕",
        description: "Add and subtract within 1000",
        problems: [
          { q: "What is 347 + 256?", a: "603", hint: "Break it: 300+200=500, 47+56=103, so 500+103=603" },
          { q: "What is 512 - 278?", a: "234", hint: "Try: 512-200=312, 312-78=234" },
          { q: "What is 689 + 143?", a: "832", hint: "Add hundreds: 600+100=700, then 89+43=132, so 700+132=832" },
          { q: "What is 900 - 364?", a: "536", hint: "900-300=600, 600-64=536" },
          { q: "What is 428 + 375?", a: "803", hint: "400+300=700, 28+75=103, so 700+103=803" },
        ],
      },
      {
        id: "g3-multiply",
        name: "Multiplication",
        emoji: "✖️",
        description: "Multiply up to 10×10",
        problems: [
          { q: "What is 7 × 8?", a: "56", hint: "7×8: think 7×7=49, then add 7 more = 56" },
          { q: "What is 9 × 6?", a: "54", hint: "9×6: use 10×6=60 minus 6 = 54" },
          { q: "What is 4 × 7?", a: "28", hint: "4×7: double 4×3=12, double again for 4×6=24, +4=28" },
          { q: "What is 8 × 8?", a: "64", hint: "8×8 is a square number: 64!" },
          { q: "What is 6 × 9?", a: "54", hint: "6×9: think 6×10=60, subtract 6 = 54" },
        ],
      },
      {
        id: "g3-fractions",
        name: "Fractions Intro",
        emoji: "🍕",
        description: "Understand halves, thirds, quarters",
        problems: [
          { q: "What fraction is shaded if 1 out of 4 equal parts is colored?", a: "1/4", hint: "The bottom number (denominator) is total parts, top (numerator) is shaded parts" },
          { q: "Which is larger: 1/2 or 1/4?", a: "1/2", hint: "Larger denominator = smaller piece. Half a pizza is bigger than a quarter!" },
          { q: "What is 1/2 + 1/2?", a: "1", hint: "Two halves make one whole!" },
          { q: "If a pizza is cut into 3 equal slices and you eat 2, what fraction did you eat?", a: "2/3", hint: "You ate 2 out of 3 total slices = 2/3" },
          { q: "What fraction of 12 is 6?", a: "1/2", hint: "6 is half of 12, so the fraction is 1/2" },
        ],
      },
    ],
  },
  4: {
    label: "Grade 4",
    emoji: "🌿",
    color: "#4ECDC4",
    topics: [
      {
        id: "g4-multiply",
        name: "Multi-digit Multiplication",
        emoji: "✖️",
        description: "Multiply 2-digit by 2-digit numbers",
        problems: [
          { q: "What is 23 × 14?", a: "322", hint: "23×14 = 23×10 + 23×4 = 230 + 92 = 322" },
          { q: "What is 35 × 12?", a: "420", hint: "35×12 = 35×10 + 35×2 = 350 + 70 = 420" },
          { q: "What is 46 × 21?", a: "966", hint: "46×21 = 46×20 + 46×1 = 920 + 46 = 966" },
          { q: "What is 18 × 15?", a: "270", hint: "18×15 = 18×10 + 18×5 = 180 + 90 = 270" },
          { q: "What is 27 × 33?", a: "891", hint: "27×33 = 27×30 + 27×3 = 810 + 81 = 891" },
        ],
      },
      {
        id: "g4-division",
        name: "Long Division",
        emoji: "➗",
        description: "Divide 3-digit numbers by 1-digit",
        problems: [
          { q: "What is 144 ÷ 6?", a: "24", hint: "144÷6: 6×20=120, 144-120=24, 24÷6=4, so answer is 24" },
          { q: "What is 195 ÷ 5?", a: "39", hint: "195÷5: 5×30=150, 195-150=45, 45÷5=9, answer = 39" },
          { q: "What is 252 ÷ 7?", a: "36", hint: "252÷7: 7×30=210, 252-210=42, 42÷7=6, answer = 36" },
          { q: "What is 168 ÷ 8?", a: "21", hint: "168÷8: 8×20=160, 168-160=8, 8÷8=1, answer = 21" },
          { q: "What is 243 ÷ 9?", a: "27", hint: "243÷9: 9×20=180, 243-180=63, 63÷9=7, answer = 27" },
        ],
      },
      {
        id: "g4-fractions",
        name: "Equivalent Fractions",
        emoji: "⚖️",
        description: "Find and compare equivalent fractions",
        problems: [
          { q: "What fraction is equivalent to 1/2 with denominator 8?", a: "4/8", hint: "Multiply top and bottom by 4: 1×4/2×4 = 4/8" },
          { q: "What fraction is equivalent to 2/3 with denominator 9?", a: "6/9", hint: "Multiply top and bottom by 3: 2×3/3×3 = 6/9" },
          { q: "Simplify 6/8 to lowest terms.", a: "3/4", hint: "GCD of 6 and 8 is 2. Divide both by 2: 6÷2/8÷2 = 3/4" },
          { q: "Is 3/4 greater than 2/3?", a: "yes", hint: "Convert to same denominator: 9/12 vs 8/12. 9/12 > 8/12, so 3/4 > 2/3" },
          { q: "What is 3/4 + 1/4?", a: "1", hint: "Same denominator: add numerators 3+1=4, so 4/4=1" },
        ],
      },
    ],
  },
  5: {
    label: "Grade 5",
    emoji: "⭐",
    color: "#FFE66D",
    topics: [
      {
        id: "g5-decimals",
        name: "Decimals",
        emoji: "🔢",
        description: "Add, subtract, multiply decimals",
        problems: [
          { q: "What is 3.4 + 2.67?", a: "6.07", hint: "Line up decimal points: 3.40 + 2.67 = 6.07" },
          { q: "What is 5.8 - 2.35?", a: "3.45", hint: "5.80 - 2.35 = 3.45 (remember to line up decimals!)" },
          { q: "What is 2.5 × 4?", a: "10", hint: "2.5×4 = 2×4 + 0.5×4 = 8 + 2 = 10" },
          { q: "What is 7.2 ÷ 3?", a: "2.4", hint: "72÷3=24, then place decimal: 2.4" },
          { q: "Round 4.567 to the nearest hundredth.", a: "4.57", hint: "Look at thousandths digit (7 ≥ 5), so round up hundredths: 4.57" },
        ],
      },
      {
        id: "g5-geometry",
        name: "Geometry",
        emoji: "📐",
        description: "Area, perimeter, volume of shapes",
        problems: [
          { q: "Find the area of a rectangle with length 8 cm and width 5 cm.", a: "40", hint: "Area = length × width = 8 × 5 = 40 cm²" },
          { q: "Find the perimeter of a square with side 7 m.", a: "28", hint: "Perimeter = 4 × side = 4 × 7 = 28 m" },
          { q: "Find the volume of a cube with side 4 cm.", a: "64", hint: "Volume = side³ = 4×4×4 = 64 cm³" },
          { q: "Find the area of a triangle with base 10 cm and height 6 cm.", a: "30", hint: "Area = (base × height) ÷ 2 = (10 × 6) ÷ 2 = 30 cm²" },
          { q: "A rectangle has area 48 cm² and length 8 cm. What is its width?", a: "6", hint: "Width = Area ÷ Length = 48 ÷ 8 = 6 cm" },
        ],
      },
    ],
  },
  6: {
    label: "Grade 6",
    emoji: "🚀",
    color: "#A8E6CF",
    topics: [
      {
        id: "g6-ratios",
        name: "Ratios & Proportions",
        emoji: "📊",
        description: "Understand and apply ratios",
        problems: [
          { q: "If a recipe needs 2 cups flour for every 3 cups sugar, how many cups of flour for 9 cups sugar?", a: "6", hint: "Set up proportion: 2/3 = x/9. Cross multiply: 3x=18, x=6" },
          { q: "Simplify the ratio 15:25.", a: "3:5", hint: "GCD of 15 and 25 is 5. Divide both: 15÷5 : 25÷5 = 3:5" },
          { q: "If 5 books cost $30, how much do 8 books cost?", a: "48", hint: "Cost per book = 30÷5 = $6. Then 6×8 = $48" },
          { q: "Write 4:6 as a fraction in simplest form.", a: "2/3", hint: "4/6 simplified: divide by GCD 2 → 2/3" },
          { q: "If the ratio of boys to girls is 3:4 and there are 12 boys, how many girls?", a: "16", hint: "12÷3=4 (scale factor). Girls = 4×4 = 16" },
        ],
      },
      {
        id: "g6-percent",
        name: "Percentages",
        emoji: "💯",
        description: "Calculate percentages and discounts",
        problems: [
          { q: "What is 25% of 80?", a: "20", hint: "25% = 1/4. So 80÷4 = 20" },
          { q: "What is 15% of 200?", a: "30", hint: "10% of 200=20, 5% of 200=10, so 15% = 30" },
          { q: "A shirt costs $40. It's on 30% sale. What is the discount?", a: "12", hint: "30% of $40 = 0.30 × 40 = $12 discount" },
          { q: "What percent is 18 out of 72?", a: "25", hint: "18/72 = 1/4 = 25%" },
          { q: "If a price increased from $50 to $60, what is the percentage increase?", a: "20", hint: "Increase = 10. Percentage = (10/50) × 100 = 20%" },
        ],
      },
      {
        id: "g6-algebra-intro",
        name: "Intro to Algebra",
        emoji: "🔤",
        description: "Solve simple equations",
        problems: [
          { q: "Solve for x: x + 7 = 15", a: "8", hint: "Subtract 7 from both sides: x = 15 - 7 = 8" },
          { q: "Solve for y: 3y = 21", a: "7", hint: "Divide both sides by 3: y = 21 ÷ 3 = 7" },
          { q: "Solve for x: x - 5 = 12", a: "17", hint: "Add 5 to both sides: x = 12 + 5 = 17" },
          { q: "Solve for n: 2n + 3 = 13", a: "5", hint: "Subtract 3: 2n=10, divide by 2: n=5" },
          { q: "Evaluate 4x - 2 when x = 3", a: "10", hint: "Substitute: 4(3) - 2 = 12 - 2 = 10" },
        ],
      },
    ],
  },
  7: {
    label: "Grade 7",
    emoji: "🌟",
    color: "#FF8B94",
    topics: [
      {
        id: "g7-integers",
        name: "Integers & Negatives",
        emoji: "⁻",
        description: "Operations with negative numbers",
        problems: [
          { q: "What is -5 + 8?", a: "3", hint: "Start at -5, move 8 right on number line = 3" },
          { q: "What is -3 × -4?", a: "12", hint: "Negative × Negative = Positive: 3×4=12" },
          { q: "What is -12 ÷ 3?", a: "-4", hint: "Negative ÷ Positive = Negative: 12÷3=4, so -4" },
          { q: "What is 7 - (-5)?", a: "12", hint: "Subtracting negative = adding positive: 7+5=12" },
          { q: "Order from least to greatest: -3, 5, -7, 2", a: "-7, -3, 2, 5", hint: "Negatives are less than positives. More negative = smaller." },
        ],
      },
      {
        id: "g7-algebra",
        name: "Algebra",
        emoji: "🧮",
        description: "Linear equations & expressions",
        problems: [
          { q: "Solve: 2x + 5 = 17", a: "6", hint: "Subtract 5: 2x=12, divide by 2: x=6" },
          { q: "Simplify: 3x + 2x - x", a: "4x", hint: "Combine like terms: (3+2-1)x = 4x" },
          { q: "Solve: 4(x + 2) = 20", a: "3", hint: "Distribute: 4x+8=20, subtract 8: 4x=12, divide: x=3" },
          { q: "If y = 2x + 1, find y when x = 4", a: "9", hint: "Substitute x=4: y = 2(4)+1 = 8+1 = 9" },
          { q: "Solve: 3x - 7 = 2x + 5", a: "12", hint: "Move x terms: 3x-2x = 5+7, so x=12" },
        ],
      },
      {
        id: "g7-geometry",
        name: "Geometry & Angles",
        emoji: "📐",
        description: "Angle relationships and triangles",
        problems: [
          { q: "Two angles are supplementary. One is 65°. What is the other?", a: "115", hint: "Supplementary angles add to 180°: 180-65=115°" },
          { q: "Two angles are complementary. One is 38°. What is the other?", a: "52", hint: "Complementary angles add to 90°: 90-38=52°" },
          { q: "A triangle has angles 50° and 70°. What is the third angle?", a: "60", hint: "Angles in triangle sum to 180°: 180-50-70=60°" },
          { q: "What is the circumference of a circle with radius 5? (Use π ≈ 3.14)", a: "31.4", hint: "C = 2πr = 2 × 3.14 × 5 = 31.4" },
          { q: "What is the area of a circle with radius 4? (Use π ≈ 3.14)", a: "50.24", hint: "A = πr² = 3.14 × 4² = 3.14 × 16 = 50.24" },
        ],
      },
    ],
  },
  8: {
    label: "Grade 8",
    emoji: "💫",
    color: "#6C63FF",
    topics: [
      {
        id: "g8-linear",
        name: "Linear Functions",
        emoji: "📈",
        description: "Slope, y-intercept, graphing lines",
        problems: [
          { q: "Find the slope of a line passing through (2,3) and (6,11).", a: "2", hint: "Slope = (y2-y1)/(x2-x1) = (11-3)/(6-2) = 8/4 = 2" },
          { q: "What is the y-intercept of y = 3x + 5?", a: "5", hint: "In y=mx+b form, b is the y-intercept: b=5" },
          { q: "Write the equation of a line with slope 2 and y-intercept -3.", a: "y=2x-3", hint: "Use y=mx+b: m=2, b=-3, so y=2x-3" },
          { q: "What is the slope of a horizontal line?", a: "0", hint: "Horizontal lines have no rise, only run: slope = 0/run = 0" },
          { q: "If y = -2x + 6, what is y when x = 4?", a: "-2", hint: "y = -2(4)+6 = -8+6 = -2" },
        ],
      },
      {
        id: "g8-pythagorean",
        name: "Pythagorean Theorem",
        emoji: "📐",
        description: "a² + b² = c²",
        problems: [
          { q: "Find the hypotenuse of a right triangle with legs 3 and 4.", a: "5", hint: "a²+b² = c²: 9+16=25, c=√25=5" },
          { q: "Find the missing leg if hypotenuse=13 and one leg=5.", a: "12", hint: "b²=c²-a²=169-25=144, b=√144=12" },
          { q: "Find the hypotenuse of a right triangle with legs 6 and 8.", a: "10", hint: "6²+8²=36+64=100, c=√100=10" },
          { q: "Is a triangle with sides 5, 12, 13 a right triangle?", a: "yes", hint: "Check: 5²+12²=25+144=169=13² ✓ Yes!" },
          { q: "Find the diagonal of a square with side 5 cm (nearest tenth).", a: "7.1", hint: "d=√(5²+5²)=√50≈7.07≈7.1 cm" },
        ],
      },
      {
        id: "g8-systems",
        name: "Systems of Equations",
        emoji: "⚖️",
        description: "Solve two equations simultaneously",
        problems: [
          { q: "Solve: x + y = 10 and x - y = 4. What is x?", a: "7", hint: "Add equations: 2x=14, x=7" },
          { q: "Solve: x + y = 10 and x - y = 4. What is y?", a: "3", hint: "From x=7, substitute: 7+y=10, y=3" },
          { q: "Solve: 2x + y = 7 and x = 2. What is y?", a: "3", hint: "Substitute x=2: 4+y=7, y=3" },
          { q: "Solve: y = x + 2 and y = 2x. What is x?", a: "2", hint: "Set equal: x+2=2x, subtract x: 2=x" },
          { q: "Solve: y = x + 2 and y = 2x. What is y?", a: "4", hint: "x=2, so y=2(2)=4" },
        ],
      },
    ],
  },
  9: {
    label: "Grade 9",
    emoji: "🎯",
    color: "#FF6348",
    topics: [
      {
        id: "g9-quadratic",
        name: "Quadratic Equations",
        emoji: "∪",
        description: "Factor and solve quadratics",
        problems: [
          { q: "Factor: x² + 5x + 6", a: "(x+2)(x+3)", hint: "Find two numbers that multiply to 6 and add to 5: 2 and 3" },
          { q: "Solve: x² - 9 = 0", a: "x=3 or x=-3", hint: "Difference of squares: (x+3)(x-3)=0, so x=±3" },
          { q: "Use the quadratic formula to solve x² + 2x - 8 = 0. What are the roots?", a: "x=2 or x=-4", hint: "x = [-2 ± √(4+32)]/2 = [-2 ± 6]/2 = 2 or -4" },
          { q: "What is the vertex x-coordinate of y = x² - 4x + 1?", a: "2", hint: "Vertex x = -b/2a = -(-4)/2(1) = 2" },
          { q: "Factor: x² - 7x + 12", a: "(x-3)(x-4)", hint: "Find two numbers that multiply to 12 and add to -7: -3 and -4" },
        ],
      },
      {
        id: "g9-exponents",
        name: "Exponents & Radicals",
        emoji: "⚡",
        description: "Laws of exponents and simplifying",
        problems: [
          { q: "Simplify: x³ × x⁴", a: "x⁷", hint: "Multiplying same base: add exponents: 3+4=7" },
          { q: "Simplify: (x²)³", a: "x⁶", hint: "Power of power: multiply exponents: 2×3=6" },
          { q: "Simplify: x⁵ ÷ x²", a: "x³", hint: "Dividing same base: subtract exponents: 5-2=3" },
          { q: "What is x⁰ equal to?", a: "1", hint: "Any nonzero number raised to power 0 = 1" },
          { q: "Simplify: √72", a: "6√2", hint: "72=36×2, so √72=√36×√2=6√2" },
        ],
      },
    ],
  },
  10: {
    label: "Grade 10",
    emoji: "🔭",
    color: "#2ED573",
    topics: [
      {
        id: "g10-trig",
        name: "Trigonometry",
        emoji: "📐",
        description: "SOH-CAH-TOA and trig ratios",
        problems: [
          { q: "In a right triangle with hypotenuse 10 and opposite side 6, what is sin(θ)?", a: "0.6", hint: "sin = opposite/hypotenuse = 6/10 = 0.6" },
          { q: "In a right triangle with adjacent 8 and hypotenuse 10, what is cos(θ)?", a: "0.8", hint: "cos = adjacent/hypotenuse = 8/10 = 0.8" },
          { q: "What is tan(45°)?", a: "1", hint: "tan(45°) = sin(45°)/cos(45°) = (√2/2)/(√2/2) = 1" },
          { q: "If sin(θ) = 0.5, what is θ in degrees?", a: "30", hint: "sin(30°) = 0.5, so θ = 30°" },
          { q: "In a right triangle, opposite=7 and adjacent=7. What is tan(θ)?", a: "1", hint: "tan = opposite/adjacent = 7/7 = 1" },
        ],
      },
      {
        id: "g10-polynomials",
        name: "Polynomials",
        emoji: "🧩",
        description: "Add, subtract, multiply polynomials",
        problems: [
          { q: "Add: (3x² + 2x - 1) + (x² - 3x + 4)", a: "4x² - x + 3", hint: "Combine like terms: (3+1)x² + (2-3)x + (-1+4) = 4x²-x+3" },
          { q: "Multiply: (x + 3)(x + 2)", a: "x² + 5x + 6", hint: "FOIL: x²+2x+3x+6 = x²+5x+6" },
          { q: "Multiply: (x - 4)(x + 4)", a: "x² - 16", hint: "Difference of squares: (a-b)(a+b) = a²-b² = x²-16" },
          { q: "Factor completely: 2x² + 6x", a: "2x(x + 3)", hint: "Factor out GCF: 2x is common, so 2x(x+3)" },
          { q: "Expand: (x + 5)²", a: "x² + 10x + 25", hint: "(a+b)² = a²+2ab+b² = x²+10x+25" },
        ],
      },
    ],
  },
  11: {
    label: "Grade 11",
    emoji: "🌙",
    color: "#7F8CDB",
    topics: [
      {
        id: "g11-trig-advanced",
        name: "Advanced Trigonometry",
        emoji: "〰️",
        description: "Unit circle, identities, graphs",
        problems: [
          { q: "What is sin²(x) + cos²(x)?", a: "1", hint: "This is the Pythagorean identity: always equals 1" },
          { q: "What is the period of y = sin(x)?", a: "2π", hint: "sin(x) completes one cycle every 2π radians" },
          { q: "Convert 180° to radians.", a: "π", hint: "180° × (π/180°) = π radians" },
          { q: "What is cos(0°)?", a: "1", hint: "At 0°, the unit circle point is (1,0), so cos(0°)=1" },
          { q: "What is sin(90°)?", a: "1", hint: "At 90°, the unit circle point is (0,1), so sin(90°)=1" },
        ],
      },
      {
        id: "g11-stats",
        name: "Statistics",
        emoji: "📊",
        description: "Mean, median, standard deviation",
        problems: [
          { q: "Find the mean of: 4, 7, 9, 12, 8", a: "8", hint: "Mean = sum/count = (4+7+9+12+8)/5 = 40/5 = 8" },
          { q: "Find the median of: 3, 7, 2, 9, 5", a: "5", hint: "Sort: 2,3,5,7,9. Middle value = 5" },
          { q: "What is the range of: 15, 22, 8, 31, 19?", a: "23", hint: "Range = max - min = 31 - 8 = 23" },
          { q: "Find the mode of: 4, 7, 4, 2, 9, 4, 7", a: "4", hint: "Mode = most frequent value: 4 appears 3 times" },
          { q: "If the mean of 5 numbers is 10, what is their sum?", a: "50", hint: "Sum = mean × count = 10 × 5 = 50" },
        ],
      },
    ],
  },
  12: {
    label: "Grade 12",
    emoji: "🎓",
    color: "#FFA502",
    topics: [
      {
        id: "g12-calculus-intro",
        name: "Intro to Calculus",
        emoji: "∫",
        description: "Limits, derivatives, basic integrals",
        problems: [
          { q: "What is the derivative of f(x) = x²?", a: "2x", hint: "Power rule: d/dx(xⁿ) = nxⁿ⁻¹. So d/dx(x²) = 2x" },
          { q: "What is the derivative of f(x) = 5x?", a: "5", hint: "d/dx(5x) = 5. The derivative of a linear function is its slope." },
          { q: "What is the derivative of f(x) = x³ + 2x?", a: "3x² + 2", hint: "Differentiate each term: 3x² + 2" },
          { q: "Find ∫2x dx", a: "x² + C", hint: "∫xⁿ dx = xⁿ⁺¹/(n+1) + C. So ∫2x dx = x² + C" },
          { q: "What is lim(x→2) of (x² - 4)/(x - 2)?", a: "4", hint: "Factor: (x+2)(x-2)/(x-2) = x+2. Limit as x→2 = 4" },
        ],
      },
      {
        id: "g12-probability",
        name: "Probability",
        emoji: "🎲",
        description: "Combinations, permutations, probability",
        problems: [
          { q: "How many ways can you arrange 4 books in a row?", a: "24", hint: "Permutation: 4! = 4×3×2×1 = 24" },
          { q: "How many ways can you choose 2 items from 5? (order doesn't matter)", a: "10", hint: "Combination: C(5,2) = 5!/(2!×3!) = 10" },
          { q: "What is the probability of rolling a 6 on a fair die?", a: "1/6", hint: "One favorable outcome out of 6 possible = 1/6" },
          { q: "A bag has 3 red and 7 blue balls. What is P(red)?", a: "3/10", hint: "P = favorable/total = 3/(3+7) = 3/10" },
          { q: "What is the probability of flipping heads twice in a row?", a: "1/4", hint: "P(H)×P(H) = 1/2 × 1/2 = 1/4" },
        ],
      },
    ],
  },
};
